import React, { Fragment } from "react";
import { Controller, useForm } from "react-hook-form";
import { FollowUpGapTimeSettings } from "../../../../core/api/models";
import ErrorMessage from "../../../../components/text/ErrorMessage";
import { DropdownList } from "react-widgets";

const UpdateForm: React.FunctionComponent<{
  onSubmit: (data: FollowUpGapTimeSettings) => void;
  onCancel: () => void;
  isSubmitting?: boolean;
  data?: FollowUpGapTimeSettings;
  error?: string;
}> = (props) => {
  const { control, handleSubmit, errors } = useForm<FollowUpGapTimeSettings>({
    reValidateMode: "onChange",
    mode: "onSubmit",
  });

  const renderButton = () => {
    return (
      <div className="col-12">
        <div className="form-group font-weight-semibold mb-3 text-right pt-3">
          <button
            type="button"
            className="btn btn-outline-dark py-2 font-weight-semibold font-normal px-4 mr-1"
            onClick={props.onCancel}
          >
            Cancel
          </button>
          <button
            type="submit"
            className="btn btn-primary py-2 font-weight-semibold font-normal px-4 "
            disabled={props.isSubmitting}
          >
            Update
          </button>
        </div>
      </div>
    );
  };

  const renderLeadFollowUpGapTimeInHours = () => {
    return (
      <div className="col-12">
        <div className="form-group font-weight-semibold mb-3">
          <label className="font-sm text-uppercase">
            Lead Follow Up Gap Time In Hours<span className="text-danger">*</span>
          </label>
          <Controller
            control={control}
            rules={{
              required: "Hours is required",
              validate: {
                numberOnly: (value) =>
                  new RegExp("\\d+").test(value) || "Invalid value",
                min: (value) => Number(value) >= 0 || "Value shoud be positive",
              },
            }}
            name="leadFollowUpGapTimeInHours"
            defaultValue={props.data?.leadFollowUpGapTimeInHours}
            render={({ onChange, value, name }) => (
              <input
                type="number"
                min={0}
                className="form-control rounded-sm font-weight-semibold"
                placeholder="Lead Follow Up Gap Time In Hours"
                name={name}
                value={value}
                onChange={onChange}
                id="debugOtp"
              />
            )}
          />
          <ErrorMessage>
            {errors.leadFollowUpGapTimeInHours?.message}
          </ErrorMessage>
        </div>
      </div>
    );
  };

  const renderEnquiryFollowUpGapTimeInHours = () => {
    return (
      <div className="col-12">
        <div className="form-group font-weight-semibold mb-3">
          <label className="font-sm text-uppercase">
            Opportunity Follow Up Gap Time In Hours<span className="text-danger">*</span>
          </label>
          <Controller
            control={control}
            rules={{
              required: "Hours is required",
              validate: {
                numberOnly: (value) =>
                  new RegExp("\\d+").test(value) || "Invalid value",
                min: (value) => Number(value) >= 0 || "Value shoud be positive",
              },
            }}
            name="enquiryFollowUpGapTimeInHours"
            defaultValue={props.data?.enquiryFollowUpGapTimeInHours}
            render={({ onChange, value, name }) => (
              <input
                type="number"
                min={0}
                className="form-control rounded-sm font-weight-semibold"
                placeholder="Opportunity Follow Up Gap Time In Hours"
                name={name}
                value={value}
                onChange={onChange}
                id="debugOtp"
              />
            )}
          />
          <ErrorMessage>
            {errors.enquiryFollowUpGapTimeInHours?.message}
          </ErrorMessage>
        </div>
      </div>
    );
  };

  const renderQuotationFollowUpGapTimeInHours = () => {
    return (
      <div className="col-12">
        <div className="form-group font-weight-semibold mb-3">
          <label className="font-sm text-uppercase">
            Quotation Follow Up Gap Time In Hours<span className="text-danger">*</span>
          </label>
          <Controller
            control={control}
            rules={{
              required: "Hours is required",
              validate: {
                numberOnly: (value) =>
                  new RegExp("\\d+").test(value) || "Invalid value",
                min: (value) => Number(value) >= 0 || "Value shoud be positive",
              },
            }}
            name="quotationFollowUpGapTimeInHours"
            defaultValue={props.data?.quotationFollowUpGapTimeInHours}
            render={({ onChange, value, name }) => (
              <input
                type="number"
                min={0}
                className="form-control rounded-sm font-weight-semibold"
                placeholder="Quotation Follow Up Gap Time In Hours"
                name={name}
                value={value}
                onChange={onChange}
                id="debugOtp"
              />
            )}
          />
          <ErrorMessage>
            {errors.quotationFollowUpGapTimeInHours?.message}
          </ErrorMessage>
        </div>
      </div>
    );
  };

  const renderBookingFollowUpGapTimeInHours = () => {
    return (
      <div className="col-12">
        <div className="form-group font-weight-semibold mb-3">
          <label className="font-sm text-uppercase">
            Booking Follow Up Gap Time In Hours<span className="text-danger">*</span>
          </label>
          <Controller
            control={control}
            rules={{
              required: "Hours is required",
              validate: {
                numberOnly: (value) =>
                  new RegExp("\\d+").test(value) || "Invalid value",
                min: (value) => Number(value) >= 0 || "Value shoud be positive",
              },
            }}
            name="bookingFollowUpGapTimeInHours"
            defaultValue={props.data?.bookingFollowUpGapTimeInHours}
            render={({ onChange, value, name }) => (
              <input
                type="number"
                min={0}
                className="form-control rounded-sm font-weight-semibold"
                placeholder="Booking Follow Up Gap Time In Hours"
                name={name}
                value={value}
                onChange={onChange}
                id="debugOtp"
              />
            )}
          />
          <ErrorMessage>
            {errors.bookingFollowUpGapTimeInHours?.message}
          </ErrorMessage>
        </div>
      </div>
    );
  };

  const renderOverdueTimeInMinutes = () => {
    return (
      <div className="col-12">
        <div className="form-group font-weight-semibold mb-3">
          <label className="font-sm text-uppercase">
            Overdue Time In Minutes<span className="text-danger">*</span>
          </label>
          <Controller
            control={control}
            rules={{
              required: "Overdue Time In Minutes is required",
              validate: {
                numberOnly: (value) =>
                  new RegExp("\\d+").test(value) || "Invalid value",
                min: (value) => Number(value) >= 0 || "Value shoud be positive",
              },
            }}
            name="overdueTimeInMinutes"
            defaultValue={props.data?.overdueTimeInMinutes}
            render={({ onChange, value, name }) => (
              <input
                type="number"
                min={0}
                className="form-control rounded-sm font-weight-semibold"
                placeholder="Overdue Time In Minutes In Hours"
                name={name}
                value={value}
                onChange={onChange}
                id="overdueTimeInMinutes"
              />
            )}
          />
          <ErrorMessage>{errors.overdueTimeInMinutes?.message}</ErrorMessage>
        </div>
      </div>
    );
  };

  return (
    <form onSubmit={handleSubmit(props.onSubmit)}>
      <div className="p-4">
        <h4 className="mb-3 font-weight-semibold">
          Update Follow Up Time Settings
        </h4>
        <div className="row gutter-10">
          {renderLeadFollowUpGapTimeInHours()}
          {renderEnquiryFollowUpGapTimeInHours()}
          {renderQuotationFollowUpGapTimeInHours()}
          {renderBookingFollowUpGapTimeInHours()}
          {renderOverdueTimeInMinutes()}
          <ErrorMessage>{props.error}</ErrorMessage>
          {renderButton()}
        </div>
      </div>
    </form>
  );
};

export default UpdateForm;
